exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".non-business-tooltip .warning-icon {\n  color: #cc3b26 !important;\n}\n.non-business-tooltip .warning-icon svg {\n  width: 12px;\n  height: 12px;\n}\n", ""]);

